import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=7bc5e007&"
import script from "./UserName.vue?vue&type=script&lang=ts&"
export * from "./UserName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports